module.exports = __webpack_public_path__ + "img/okboy.19f3fef3.png";